<template>
  <div class="main-page">
    <keep-alive :include="cachedViews">
      <router-view :key="key" />
    </keep-alive>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Layout',
  watch: {
    $route() {
      this.addTags();
    }
  },
  computed: {
    ...mapGetters(['cachedViews']),
    key() {
      return this.$route.fullPath
    }
  },
  mounted() {
    this.addTags()
  },
  methods: {
    addTags() {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addCachedView', this.$route)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.main-page { min-height: 100vh; }
</style>
